import validate from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}